import React, { useState, useEffect, useCallback } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import { NavLink } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import Examination_navbar from "./Examination_navbar";
import ShowExam from "../Shared/ShowExam";
import WingsDropDown from "../Shared/WingsDropDown";
import Pagination from "../General/Pagination";

function ExamClasses() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(true);
  const [listOfLedger, setLedger] = useState([]);
  const [loadingItem, setLoadingItem] = useState(null);
  const [examReadOnly, setExamReadOnly] = useState(false);
  const [examSessionId, setExamSessionId] = useState("0");
  const [examSessionName, setExamSessionName] = useState("");

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [WingId, setWingId] = useState("0");

  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [pendingRemoval, setPendingRemoval] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const params = useParams();
  const examId = parseInt(params.id, 10) || 0;

  const handleExamLoaded = useCallback((exam) => {
    const status = (exam.Current_Status || "").toString().toLowerCase();
    setExamReadOnly(status === "closed");
    if (exam.Session_ID) {
      setExamSessionId(String(exam.Session_ID));
    }
    if (exam.SessionName || exam.Session_Name) {
      setExamSessionName(exam.SessionName || exam.Session_Name);
    }
  }, []);

  const fetchClasses = useCallback(() => {
    if (examId <= 0) {
      setLoading(false);
      setLedger([]);
      return;
    }

    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      ExamID: examId,
      SessionID: parseInt(examSessionId, 10) || 0,
      Wing_Id: parseInt(WingId, 10) || 0,
    };

    axios({
      method: "post",
      url: config.base_url + "Exam/GetExamClasses",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        setLoading(false);
        if (response.data.status_code === 1) {
          setLedger(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
          if (response.data.ExamSessionID) {
            setExamSessionId(String(response.data.ExamSessionID));
          }
        } else {
          setLedger([]);
          setTotalRecords(0);
          if (
            response.data.status_message &&
            response.data.status_code !== 0
          ) {
            toast.warning(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
      })
      .catch(function () {
        setLoading(false);
        setLedger([]);
        setTotalRecords(0);
        toast.error("Unable to load exam classes. Please try again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, [
    AccessKey,
    UserID,
    MemberType,
    pageNo,
    pageSize,
    examId,
    examSessionId,
    WingId,
  ]);

  useEffect(() => {
    document.title = "Manage Exam Classes";
    fetchClasses();
  }, [fetchClasses]);

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const handleWingChange = (e) => {
    setWingId(e.target.value);
    setPageNo(1);
  };

  const handlePageSizeChange = (e) => {
    setPageSize(parseInt(e.target.value, 10) || 10);
    setPageNo(1);
  };

  const setClassSelected = (classId, isSelected) => {
    setLedger((prev) =>
      prev.map((item) =>
        item.Class_Id === classId ? { ...item, IsSelected: isSelected } : item
      )
    );
  };

  const submitClassChange = (classId, isSelected, confirmCascadeDelete) => {
    return axios({
      method: "post",
      url: config.base_url + "Exam/AddRemoveClassInExam",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        Class_Id: classId,
        ExamID: examId,
        hasRights: isSelected,
        ConfirmCascadeDelete: confirmCascadeDelete,
      },
    });
  };

  const handleClassApiResponse = (classId, previousChecked, response) => {
    setLoadingItem(null);
    const code = response.data?.status_code;
    const message = response.data?.status_message || "Request failed.";

    if (code === 1) {
      setClassSelected(classId, !previousChecked);
      toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    if (code === 3) {
      setClassSelected(classId, previousChecked);
      setPendingRemoval({
        classId,
        marksCount: response.data.MarksCount || 0,
        sectionSubjectsCount: response.data.SectionSubjectsCount || 0,
        resultSummaryCount: response.data.ResultSummaryCount || 0,
        message: message,
      });
      setShowRemoveModal(true);
      return;
    }

    setClassSelected(classId, previousChecked);
    if (code === 0) {
      toast.warning(message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      toast.error(message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const UpdateClass = (e, classId) => {
    e.preventDefault();
    if (examReadOnly) {
      toast.warning("This exam is closed. Classes cannot be changed.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const newChecked = e.target.checked;
    const previousChecked = !newChecked;
    setLoadingItem(classId);

    if (newChecked) {
      setClassSelected(classId, true);
    }

    submitClassChange(classId, newChecked, false)
      .then(function (response) {
        handleClassApiResponse(classId, previousChecked, response);
      })
      .catch(function () {
        setLoadingItem(null);
        setClassSelected(classId, previousChecked);
        toast.error("Unable to update class. Please try again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleConfirmRemoval = () => {
    if (!pendingRemoval) {
      return;
    }

    setConfirmLoading(true);
    submitClassChange(pendingRemoval.classId, false, true)
      .then(function (response) {
        setConfirmLoading(false);
        const code = response.data?.status_code;
        const message = response.data?.status_message || "Request failed.";

        if (code === 1) {
          setClassSelected(pendingRemoval.classId, false);
          toast.success(message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setShowRemoveModal(false);
          setPendingRemoval(null);
          return;
        }

        if (code === 0) {
          toast.warning(message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.error(message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function () {
        setConfirmLoading(false);
        toast.error("Unable to remove class. Please try again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleCloseRemoveModal = () => {
    if (confirmLoading) {
      return;
    }
    setShowRemoveModal(false);
    setPendingRemoval(null);
  };

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      let count = 1;
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{count++ + pageSize * (pageNo - 1)}</td>
            <td>{item.Class_Id}</td>
            <td>{item.Class_Code}</td>
            <td>{item.Class_Short_Name}</td>
            <td>{item.Class_Name}</td>
            <td>{item.Wing_Name}</td>
            <td>{item.Session_Name}</td>
            <td>
              {loadingItem === item.Class_Id ? (
                <Spinner animation="grow" size="sm" />
              ) : (
                <div className="form-check">
                  <input
                    className="form-check-input"
                    checked={!!item.IsSelected}
                    type="checkbox"
                    disabled={examReadOnly}
                    onChange={(e) => UpdateClass(e, item.Class_Id)}
                  />
                </div>
              )}
            </td>
          </tr>
        );
      });
    }

    if (!loading) {
      return (
        <tr>
          <td colSpan="8">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }

    return null;
  };

  return (
    <>
      <ToastContainer />

      <Modal show={showRemoveModal} onHide={handleCloseRemoveModal}>
        <Modal.Header closeButton>
          <Modal.Title>Remove Class from Exam</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {pendingRemoval && (
            <>
              <p>{pendingRemoval.message}</p>
              <ul className="mb-0">
                {pendingRemoval.marksCount > 0 && (
                  <li>{pendingRemoval.marksCount} mark record(s) will be deleted</li>
                )}
                {pendingRemoval.sectionSubjectsCount > 0 && (
                  <li>
                    {pendingRemoval.sectionSubjectsCount} section subject
                    setup(s) will be deleted
                  </li>
                )}
                {pendingRemoval.resultSummaryCount > 0 && (
                  <li>
                    {pendingRemoval.resultSummaryCount} result summary record(s)
                    will be deleted
                  </li>
                )}
              </ul>
              <p className="text-muted small mt-3 mb-0">
                Published result cards are not removed automatically. Review
                published results separately if needed.
              </p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="button button-white"
            onClick={handleCloseRemoveModal}
            disabled={confirmLoading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="button button-primary"
            onClick={handleConfirmRemoval}
            disabled={confirmLoading}
          >
            {confirmLoading ? "Removing..." : "Remove Class"}
          </button>
        </Modal.Footer>
      </Modal>

      <Examination_navbar />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/ExaminationSystem/ExaminationDashboard">
                        Examinations
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Manage Exam Classes
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Manage Exam Classes</div>
              </div>
            </div>
          </div>
        </div>

        <div className="collapse show" id="collapseFilteres">
          <div className="page-content">
            <div className="container">
              <ShowExam ExamID={examId} onExamLoaded={handleExamLoaded} />
              {examReadOnly && (
                <div className="alert alert-warning py-2 mb-2" role="alert">
                  This exam is closed. Class selection is read-only.
                </div>
              )}
              <div className="card mb-2">
                <div className="card-body">
                  <div className="row align-items-end gy-3">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Exam Session:</label>
                        <div className="label-gray">
                          {examSessionName || examSessionId || "—"}
                        </div>
                        <div className="text-muted small">
                          Classes are always listed for the exam&apos;s session.
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Select Wing:</label>
                        <select
                          name="WingId"
                          value={WingId}
                          onChange={handleWingChange}
                          className="form-select"
                        >
                          <option value="0">---All---</option>
                          <WingsDropDown />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-5 text-md-end">
                      <span className="text-muted small">
                        {totalRecords > 0
                          ? `${totalRecords} class(es) found`
                          : loading
                          ? "Loading classes..."
                          : "No classes to display"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card mt-2">
                <div className="card-body">
                  <table className="table table-theme table-hover">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Class ID</th>
                        <th>Class Code</th>
                        <th>Class Short Name</th>
                        <th>Class Name</th>
                        <th>Wing Name</th>
                        <th>Session</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td className="text-center" colSpan="8">
                            <Spinner animation="border" role="status"></Spinner>
                          </td>
                        </tr>
                      ) : (
                        <>{renderLedger()}</>
                      )}
                    </tbody>
                  </table>

                  {totalRecords > pageSize && (
                    <div className="pagination-wrap mt-3">
                      <div className="row align-items-center">
                        <div className="col-md-2 form_default">
                          <div className="d-flex align-items-center">
                            <label className="me-2" style={{ fontSize: "15px" }}>
                              Page Size
                            </label>
                            <div className="form-group">
                              <select
                                className="form-select"
                                style={{ width: "100px" }}
                                value={pageSize}
                                onChange={handlePageSizeChange}
                              >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <Pagination
                          pageNo={pageNo}
                          pageSize={pageSize}
                          totalRecords={totalRecords}
                          onPageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExamClasses;
